export default {"src":"/_next/static/media/500.56132d81.svg","height":383,"width":663,"blurWidth":0,"blurHeight":0};